import React, {useState, useEffect,useContext} from 'react';
import {Responsive, WidthProvider} from 'react-grid-layout';
import ParentRelationDataTable from '../info-data-table/components/ParentRelationDataTable';
import "../grid-layout.css";
import {useDispatch} from 'react-redux';
import {Button} from 'info-ui-library';
import {themes} from '../theme/ThemeOptions';
import ParentRelationModal from './ParentRelationModal';
import { resolveColor } from '../theme/ThemeOptions';
import { ThemeContext } from '../theme/ThemeContext';
import styled from 'styled-components';

const ResponsiveReactGridLayout = WidthProvider(Responsive);
export const StyleResponsiveReactGridLayout = styled(ResponsiveReactGridLayout)`
&.react-grid-layout > .layout{
  background: ${ p =>
        resolveColor(p.ioTheme, p.ioMode, p.styleName, 'background')};
  color: ${ p => resolveColor(p.ioTheme, p.ioMode, p.styleName, 'color')};
  overflow-y:visible !important;
}
`
const StyledButton = styled(Button)`
background: ${ p =>
        resolveColor(p.ioTheme, p.ioMode, p.styleName, 'background')};
color: ${ p =>
        resolveColor(p.ioTheme, p.ioMode, p.styleName, 'color')};
`;
interface IConfigPortalDatagrid {
    className?: string,
    rowHeight?: number,
    cols?: any,
    breakpoints?: any,
    setFormData:any,
    formData:any
}


const ParentRelation : React.FC < IConfigPortalDatagrid > = (props : IConfigPortalDatagrid) => {
    const dispatch = useDispatch();
    const themeContext = useContext(ThemeContext);
    const [IsModalVisible,
        SetModalVisible] = useState(false)

    let layouts = [
        {
            i: "menu",
            x: 0,
            y: 0,
            w: 12,
            h: 2
        }, {
            i: "datagrid",
            x: 0,
            y: 2,
            w: 12,
            h: 15
        }
    ]

    return (
        <div>
            <StyleResponsiveReactGridLayout
                styleName={themeContext.styleName}
                ioTheme={themeContext.ioTheme}
                ioMode={themeContext.ioMode}
                className="layout"
                layouts={{
                "lg": layouts
            }}
                rowHeight={props.rowHeight}
                cols={props.cols}
                isDraggable={false}
                isResizable={false}
                margin={[5, 5]}>
                <div key="datagrid">
                    <StyledButton styleName={themeContext.styleName}
                        ioTheme={themeContext.ioTheme}
                        ioMode={themeContext.ioMode}
                        name={''}
                        onClick={() => {SetModalVisible(true)}}
                        className='fa fa-plus'/>
                    <ParentRelationDataTable setFormData={props.setFormData} formData={props.formData}/>
                    </div>
            </StyleResponsiveReactGridLayout>
            {IsModalVisible && <ParentRelationModal setFormData={props.setFormData} formData={props.formData} SetModalVisible={SetModalVisible}/>}
        </div>
    );
}

ParentRelation.defaultProps = {
    className: "layout",
    rowHeight: 25,
    cols: {
        lg: 12,
        md: 10,
        sm: 6,
        xs: 4,
        xxs: 2
    },
    breakpoints: {
        lg: 1200,
        md: 996,
        sm: 768,
        xs: 480,
        xxs: 0
    }
};
export default(ParentRelation);
